import { useContext, useEffect, type FC, type ReactNode } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/routes/paths';
import { AuthContext } from 'src/contexts/auth';
import { useNavigate } from 'react-router';

const TOP_NAV_HEIGHT = 64;

const LayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top center',
  backgroundImage: 'url("/assets/gradient-bg.svg")',
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  height: '100%',
}));

interface LayoutProps {
  children: ReactNode;
}

export const Layout: FC<LayoutProps> = props => {
  const { children } = props;
  const router = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  if (isAuthenticated) {
    router(paths.dashboard.root);
  }
  return (
    <LayoutRoot>
      <Box
        component="header"
        sx={{
          left: 0,
          position: 'fixed',
          right: 0,
          top: 0,
          zIndex: theme => theme.zIndex.appBar,
        }}
      >
        <Container maxWidth={false}>
          <Stack spacing={2} sx={{ height: TOP_NAV_HEIGHT }} direction="row">
            <Stack
              alignItems="center"
              display="inline-flex"
              href={paths.dashboard.root}
              spacing={1}
              sx={{ textDecoration: 'none' }}
              component={RouterLink}
              direction="row"
            >
              {/* <Box
                sx={{
                  display: "inline-flex",
                  height: 24,
                  width: 24,
                }}
              >
                <img src={LogoImage} height={24} width={24} alt="logo" />
              </Box> */}
              <Box
                sx={{
                  'color': 'text.primary',
                  'fontFamily': "'Plus Jakarta Sans', sans-serif",
                  'fontSize': 14,
                  'fontWeight': 800,
                  'letterSpacing': '0.3px',
                  'lineHeight': 2.5,
                  '& span': {
                    color: 'primary.main',
                  },
                }}
              >
                Truck Load
              </Box>
            </Stack>
          </Stack>
        </Container>
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          flex: '1 1 auto',
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            py: {
              xs: '60px',
              md: '120px',
            },
          }}
        >
          {children}
        </Container>
      </Box>
    </LayoutRoot>
  );
};
